import React from "react";

import Select from "antd/es/select";
import { useIntl } from "react-intl";

import ForecastViewMode from "../enum/ForecastViewMode";

interface Props {
  onChange: (value: ForecastViewMode) => void;
  value: ForecastViewMode;
}

const ForecastViewSelection: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();
  return (
    <Select onChange={onChange} value={value}>
      <Select.Option value={ForecastViewMode.MONTH}>
        {intl.formatMessage({
          id: "deal.forecastViewSelection.month",
          defaultMessage: "View By Month",
          description: "Deal card view. Forecast view selection - view by month",
        })}
      </Select.Option>
      <Select.Option value={ForecastViewMode.QUARTER}>
        {intl.formatMessage({
          id: "deal.forecastViewSelection.quarter",
          defaultMessage: "View By Quarter",
          description: "Deal card view. Forecast view selection - view by quarter",
        })}
      </Select.Option>
    </Select>
  );
};

export default ForecastViewSelection;
